import React from 'react';
export function MechanismSection() {
  return <section className="bg-dark-green text-off-white py-24 px-4" data-id="element-88">
      <div className="max-w-4xl mx-auto text-center space-y-10" data-id="element-89">
        <span className="font-sans text-sage tracking-widest uppercase text-sm font-semibold" data-id="element-90">
          El Mecanismo Único
        </span>
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-91">
          El "Freno del Cortisol"
        </h2>
        <div className="w-24 h-px bg-sage/50 mx-auto" data-id="element-92"></div>
        <p className="text-xl font-sans text-cream/90 leading-relaxed max-w-3xl mx-auto" data-id="element-93">
          Este protocolo no cuenta calorías; resetea señales químicas. A través
          de la{' '}
          <strong className="text-white font-semibold" data-id="element-94">
            Hidratación Iónica
          </strong>{' '}
          y la{' '}
          <strong className="text-white font-semibold" data-id="element-95">
            Seguridad Celular
          </strong>
          , le enviamos un mensaje directo a tus glándulas suprarrenales:{' '}
          <em data-id="element-96">"El peligro ha pasado"</em>.
        </p>
        <p className="text-lg font-sans text-sage/90 leading-relaxed max-w-2xl mx-auto" data-id="element-97">
          Cuando tu cuerpo se siente seguro, desbloquea los riñones y el sistema
          linfático, liberando el exceso de volumen en cuestión de horas.
        </p>
      </div>
    </section>;
}